export const SITE_URL = "https://omondijeff.dev";
export const SITE_NAME = "Jeffrey Omondi";
export const SITE_TITLE = "Jeffrey Omondi | DevOps Engineer & AI Automation Specialist";
export const SITE_DESCRIPTION =
  "DevOps Engineer and AI Automation Specialist. Production systems across East Africa and internationally — SaaS, cloud-native infrastructure, AI automation, and the work behind Tajilabs.";
export const AUTHOR = {
  name: "Jeffrey Omondi",
  email: "jeffomondi.eng@gmail.com",
  jobTitle: "DevOps Engineer & AI Automation Specialist",
  sameAs: ["https://github.com/raburujeff", "https://linkedin.com/in/omondijeff"],
};

export const absUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (path.startsWith("http")) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
